// components/integrations/shared/NewKeyNotification.tsx
import React from 'react';
import { CheckCircle, Copy, X } from 'lucide-react';
import { alertSuccess } from '../../../helpers/alertError';

interface NewKeyNotificationProps {
  newKey: string | null;
  onClose: () => void;
  onCopy: (text: string, key: string) => void;
}

export const NewKeyNotification: React.FC<NewKeyNotificationProps> = ({
  newKey,
  onClose,
  onCopy,
}) => {
  if (!newKey) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 max-w-md bg-white rounded-xl shadow-2xl border border-green-200 p-6 animate-slide-up">
      <button
        onClick={onClose}
        className="absolute top-3 right-3 text-slate-400 hover:text-slate-600"
      >
        <X size={18} />
      </button>
      <div className="flex items-start gap-3">
        <CheckCircle size={24} className="text-green-600 flex-shrink-0 mt-1" />
        <div>
          <h4 className="font-semibold text-slate-800">Clé API créée</h4>
          <p className="text-sm text-slate-600 mt-1">Conservez cette clé, elle ne sera plus affichée :</p>
          <code className="block mt-2 p-2 bg-slate-50 border border-slate-200 rounded text-xs font-mono break-all">
            {newKey}
          </code>
          <button
            onClick={() => {
              onCopy(newKey, 'newKey');
              alertSuccess('Clé copiée dans le presse-papier');
            }}
            className="mt-2 text-primary hover:text-primary/80 text-sm font-medium flex items-center gap-1"
          >
            <Copy size={14} />
            Copier la clé
          </button>
          <button
            onClick={onClose}
            className="mt-2 ml-4 text-slate-400 hover:text-slate-600 text-sm"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};